import { render, staticRenderFns } from "./RevisionHistory.vue?vue&type=template&id=1c225471"
import script from "./RevisionHistory.vue?vue&type=script&lang=js"
export * from "./RevisionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports